import styled from "styled-components";

interface IButtonLabelProps {
    fontSize: number;
    lateralPadding: number;
    allowLabelWrap?: boolean;
}

export const ButtonLabelBox = styled.span<IButtonLabelProps>`
    text-transform: uppercase;
    padding: 1px ${({lateralPadding}) => lateralPadding}em 0px;
    font-size: ${({fontSize}) => fontSize}em;
    line-height: 1.15;
    max-height: 2.2em;

    white-space: ${({allowLabelWrap}) => allowLabelWrap ? 'unset' : 'nowrap'};
    overflow: hidden;
    text-overflow: ellipsis;
`;
